import AnalyticsPage from './pages/analytics/index';
import AnalyticsDetailPage from './pages/analytics/detail';
import DashboardPage from './pages/dashboards/show';
import MockTestNewPage from './pages/mock_tests/new';
import MockTestShowPage from './pages/mock_tests/show';
import OnDemandClassesIndexPage from './pages/on_demand_classes/index';
import ReviewAnswersPage from './pages/review/answers';
import ReviewPracticeSessionsPage from './pages/review/practice_sessions';
import ScoreReportShowPage from './pages/score_reports/show';
import ScoreReportRetryPage from './pages/score_reports/retry';
import AccountSettingsPage from './pages/account_settings';

// import NotFoundPage from './pages/not_found';

const routes = [
  {
    exact: true,
    path: '/analytics/:section/:unit',
    component: AnalyticsDetailPage
  },
  {
    exact: true,
    path: '/analytics',
    component: AnalyticsPage
  },
  {
    exact: true,
    path: '/answers',
    component: ReviewAnswersPage
  },
  {
    exact: true,
    path: '/on_demand_classes',
    component: OnDemandClassesIndexPage
  },
  {
    exact: true,
    path: '/practice_sessions',
    component: ReviewPracticeSessionsPage
  },
  {
    exact: true,
    path: '/practice_tests/share/:shareableId',
    component: MockTestShowPage
  },
  {
    exact: true,
    path: '/practice_tests/start',
    component: MockTestNewPage
  },
  {
    exact: true,
    path: '/practice_tests/start_section',
    component: MockTestNewPage
  },
  {
    exact: true,
    path: '/practice_tests/:id',
    component: MockTestShowPage
  },
  {
    exact: true,
    path: '/profile',
    component: AccountSettingsPage
  },
  {
    exact: true,
    path: '/score_reports/:id',
    component: ScoreReportShowPage
  },
  {
    exact: true,
    path: '/score_reports/:id/answers/:answerId',
    component: ScoreReportShowPage
  },
  {
    exact: true,
    path: '/score_reports/:id/answers/:answerId/retry',
    component: ScoreReportRetryPage
  },
  {
    exact: true,
    path: '/students/:studentId/answers',
    component: ReviewAnswersPage
  },
  {
    exact: true,
    path: '/students/:studentId/practice_sessions',
    component: ReviewPracticeSessionsPage
  },
  // {
  //   path: '*',
  //   component: NotFoundPage
  // }
];

// Mirrors the subdomain constraints of the server-side SPA dashboard pages
// (app/spa/test_prep/dashboards/pages). Registering /dashboard on other hosts would
// hijack client-side navigation that should full-page-load the legacy dashboard.
const dashboardHosts = ['toefl', 'ielts', 'ieltsgt'];

if (typeof window !== 'undefined' && dashboardHosts.some((host) => window.location.host.startsWith(host))) {
  routes.push({
    exact: true,
    path: '/dashboard',
    component: DashboardPage
  });
}

export default routes;
